module.exports = "<!-- TO BE REMOVED -->\n<div ng-show=\"!vm.dataRendered\">\n    Data Rendering...\n</div>\n";